/* istanbul ignore file */
import actions from './actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Button, ButtonPrimary} from '@homeaway/react-buttons';
import Modal from '@homeaway/react-modal';
import React from 'react';
import {getListingDeleteModalState} from './selectors';
import edap from '../edap';
import {withTranslationsAsProps} from '../../components/translations';
import './ListingDeleteModal.less';

export function ListingDeleteModal({
    confirmText,
    confirmRemove,
    confirmCancel,
    isOpen,
    onClose,
    onDelete,
    boardId,
    listingId,
    idx,
    hitTotal,
    userRole
}) {
    function handleModalClose() {
        edap.listingDeleteModalClose(boardId, listingId);
        onClose();
    }

    function handleDeleteClick() {
        onDelete(boardId, listingId);
        edap.listingDelete(boardId, listingId, idx, hitTotal, userRole);
        handleModalClose();
    }

    return (
        <Modal
            id={'listing-remove-modal'}
            isOpen={isOpen}
            onClose={handleModalClose}
        >
            <p>{confirmText}</p>
            <div className="listing-delete-modal__button">
                <Button label={confirmCancel} onClick={handleModalClose}/>
                <ButtonPrimary label={confirmRemove} onClick={handleDeleteClick}/>
            </div>
        </Modal>
    );
}

ListingDeleteModal.defaultProps = {
    onClose: () => {}
};

export const mapStateToProps = (state) => (getListingDeleteModalState(state));

export const mapDispatchToProps = {
    onClose: actions.close
};

export default compose(
    withTranslationsAsProps({
        'tripboards.main.remove.property': 'confirmText',
        'tripboards.main.yes.remove': 'confirmRemove',
        'tripboards.cancel': 'confirmCancel',
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(ListingDeleteModal);



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing-delete-modal/ListingDeleteModal.js